import React from "react";
import Modal from "../Modal";
import styled from '@emotion/styled';
import { TabbedCard } from "../Card";
import { TabController } from "../../TabController/TabController";
import { TabPanel } from "../../TabController/TabPanel";
import TextInputWithLabel from "../../Inputs/TextInput";
import TrackingDetails from "../TrackingDetails";
import OrderSummaryTable from "../OrderSummary";
import { isMobile } from "react-device-detect";
import { Alert } from "../Alert";
import { ReadonlyPrescriptionTable } from "../Opticians/PrescriptionTable";
import { StyledModal } from "../../StyledComponents/Modals/Modals";

const TabContent = styled.div`
height: 450px;
  overflow-y: auto;
  width:100%;

  padding: 0px 40px ${isMobile ? "0px" : "30px"} 40px;

  flex-grow: 1;
  & > div { 
    margin-top: 0;
  }

padding: 20px;
padding-top: 10px;
padding-bottom: 5px;
`

const PrescriptionContainerTwoColumn = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CancelButton = styled.button`
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 10px 20px;
  margin-right: 10px;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color: #5a6268;
  }
`;

const ModalFooter = styled.div`
  text-align: right;
  flex-shrink: 0;
  padding: 10px 0px;
`;

const Heading = styled.h3`
  margin: 0;
  margin-top: 10px;
  padding-bottom: 5px;
`;

const FieldContainer = styled.div`
  flex: 1;
  min-width: 120px;
  
  &:first-of-type {
    margin-left: 0;
  }
  
  @media (max-width: 768px) {
    flex-basis: 100%;
  }
`;

const trackingData = [
  {
    Employee: 'Mr Jack Wills',
    ClockNo: 124,
    ID: 893043,
    Site: '',
    OrderNo: 12587,
    CostCentre: '',
    Department: '',
    Eyewear: 'Safety',
    RaisedBy: 'cod@mcrsafetyeurope.com',
    order:
      [
        { item: 'Orca 6Rx 55 x 18 Gunmetal', product: 'Frame' },
        { item: 'Polycarbonate Standard Lens Single Vision', product: 'Rlens' },
        { item: 'Polycarbonate Standard Lens Single Vision', product: 'Llens' },
        { item: 'Hard Zip Case', product: 'Case' },
        { item: 'Standard Postage', product: 'PPA' },
      ],
    tracking:
      [
        { time: '29/08/2018 14:07:54', status: 'Order Delivered From Lab', isImportant: true },
        { time: '29/08/2018 11:51:30', status: 'At Nidek RX Robotic Edger', isImportant: false },
        { time: '29/08/2018 11:51:26', status: 'At Nidek RX Robotic Edger', isImportant: false },
        { time: '29/08/2018 11:19:54', status: 'At Nidek RX Finishing Blocker', isImportant: false },
        { time: '29/08/2018 11:10:46', status: 'Order sent to manufacturing system', isImportant: true },
        { time: '29/08/2018 11:04:38', status: 'Order received into front office system', isImportant: false },
        { time: '15/08/2018 10:17:31', status: 'EyeTicket Created', isImportant: true },
      ],
    optician: { name: 'Asda Opticians', address: 'Middlemore Lane West Aldridge WS9 8BG', distance: '0.00', dispensing: "£25.00 (st)", type: "Local", phoneNumber: "01922 457421" }
  }
];

export default function Tracking({
  showHideModal,
  isModalOpen,
  colours,
  eyeTicket
}) {

  // Ensure the Royal Mail url has a protocol so the link works correctly
  const ensureProtocol = (url) => {
    if (!url) return null;
    if (url.startsWith('http://') || url.startsWith('https://')) return url;
    return `https://${url}`;
  };

  const royalMailUrl = ensureProtocol(eyeTicket?.RoyalMailTrackingURL);

  return (
    <Modal open={isModalOpen}>
      <StyledModal>
        <TabbedCard
          label={eyeTicket.eyeticketTitle}
          headercolour={colours.sidebar}
          headerTextColour={colours.font}
          shadow={false}
          tabController={
            <TabController colours={colours}>
              <TabPanel label="Tracking" visible={true}>
                <TabContent>
                  <Heading>
                    Tracking History
                  </Heading>
                  {eyeTicket.TrackingPointStatuses.length > 0 ?
                    (<>
                      {royalMailUrl ? (
                        <a href={royalMailUrl} target="_blank" rel="noopener noreferrer">View Royal Mail Tracking</a>
                      ) : (
                        <span style={{color: '#6c757d'}}>Royal Mail tracking link unavailable</span>
                      )}
                      <TrackingDetails
                        trackingData={eyeTicket.TrackingPointStatuses} />
                    </>
                    ) : (
                      <Alert type='warning'>No tracking information available.</Alert>
                    )}

                </TabContent>
              </TabPanel>
              <TabPanel label="EyeTicket Summary" visible={true}>
                <TabContent>
                  <Heading>
                    EyeTicket Summary
                  </Heading>
                  <FieldContainer>
                    <TextInputWithLabel disabled={true} label='Employee' value={eyeTicket.eyeticketTitle} />
                  </FieldContainer>
                  <FieldContainer>
                    <TextInputWithLabel disabled={true} label='Prescription Number' value={eyeTicket.EyeTicket.eticket_barcode} />
                  </FieldContainer>
                  <FieldContainer>
                    <TextInputWithLabel disabled={true} label='SAP/Order No' value={eyeTicket.EyeTicket.eticketorderno} />
                  </FieldContainer>
                  <FieldContainer>
                    <TextInputWithLabel disabled={true} label='Eyewear' value={eyeTicket.EyeTicket.eticketsafetyorvdu} />
                  </FieldContainer>
                </TabContent>
              </TabPanel>
              <TabPanel label="Order" visible={true}>
                <TabContent>
                  <Heading>
                    Order Details
                  </Heading>
                  {eyeTicket.EyeTicketOrderDetails.length > 0 ?
                    (<OrderSummaryTable
                      items={eyeTicket.EyeTicketOrderDetails} />)
                    : (
                      <Alert type='warning'>No order details available.</Alert>
                    )}

                </TabContent>
              </TabPanel>
              {eyeTicket.Opticians[0] &&
                <TabPanel label="Optician" visible={true}>
                  <TabContent>
                    <Heading>
                      Optician
                    </Heading>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Optician Name' value={eyeTicket.Opticians[0].name} />
                    </FieldContainer>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Telephone' value={eyeTicket.Opticians[0].telno} />
                    </FieldContainer>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Address Line 1' value={eyeTicket.Opticians[0].add1} />
                    </FieldContainer>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Address Line 2' value={eyeTicket.Opticians[0].add2} />
                    </FieldContainer>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Address Line 3' value={eyeTicket.Opticians[0].add3} />
                    </FieldContainer>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Postcode' value={eyeTicket.Opticians[0].pstcode} />
                    </FieldContainer>
                  </TabContent>
                </TabPanel>}
              {eyeTicket.PrescriptionDetails?.length > 0 && eyeTicket.PrescriptionDetails[0] &&
                <TabPanel label="Prescription" visible={true}>
                  <TabContent>
                    <PrescriptionContainerTwoColumn>
                      <ReadonlyPrescriptionTable
                        colours={colours}
                        data={eyeTicket.PrescriptionDetails[0]}
                      />
                    </PrescriptionContainerTwoColumn>
                  </TabContent>
                </TabPanel>
              }
            </TabController>
          }
        >
        </TabbedCard>
        <ModalFooter>
          <CancelButton onClick={showHideModal}>Close</CancelButton>
        </ModalFooter>
      </StyledModal>
    </Modal>
  );
}
